<template>
  <CustomerSingle
    :customer="customer"
  />
</template>

<script>
import CustomerSingle from '../components/CustomerSingle'

export default {
  name: 'CustomerSinglePage',

  components: {
    CustomerSingle
  },

  async beforeRouteLeave (to, from, next) {
    if (this.customer && this.customer.isChanged) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })
      if (answer) {
        this.customer.reset()
      }
      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      title: 'Customer',
      actions: [
        {
          text: 'Save',
          event: 'save',
          disabled: true
        },
        {
          color: 'error',
          text: 'Delete',
          event: 'delete',
          disabled: true
        }
      ]
    }
  },

  data () {
    return {
      customer: {}
    }
  },

  computed: {
    saveActionStates () {
      return {
        disabled: !this.customer || this.customer.inProgress || (this.customer.errors && this.customer.errors.length > 0),
        loading: !this.customer || this.customer.inProgress
      }
    },

    deleteActionStates () {
      return {
        disabled: !this.customer || this.customer.inProgress
      }
    }
  },

  async mounted () {
    try {
      const customer = await this.$http.customer.find(this.$route.params.id)
      customer.orders = await customer.orders().params({ sort: '-created_at', page: 1, perPage: -1 }).get()
      this.customer = customer

      this.$radio.$emit('action-panel-title', this.customer.fullname)
    } catch (e) {
      this.$toast.error(this.$t(e.message))
    }

    this.$radio.$on('requested-customer-save', this.onActionSave)
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'customers' })
    },

    onActionSave () {
      let self = this
      let changedAttributes = this.customer.getChangedDefaultAttributes()

      this.customer
        .save()
        .then(async function () {
          await self.updateUser(changedAttributes)
        })
        .catch(e => {
          this.$vuetify.goTo(0)
          this.$toast.error(this.$t(e.message))
        })
    },

    async onActionDelete () {
      if (!await this.$root.$confirm(this.$t('Danger Zone'), this.$t('Please Confirm'), { color: 'red' })) {
        return
      }
      await this.customer.delete()
      this.goBack()
    },

    async updateUser (changedAttributes) {
      let shouldUpdate = false
      let user = await this.$http.make('auth:user').getByCustomerId(this.customer.id)

      if (!user.id) {
        throw new Error(this.$t('Failed to update customer\'s user'))
      }

      if (changedAttributes.includes('firstname') || changedAttributes.includes('lastname')) {
        user.name = `${this.customer.firstname} ${this.customer.lastname}`
        shouldUpdate = true
      }

      if (changedAttributes.includes('email')) {
        user.email = this.customer.email
        shouldUpdate = true
      }

      if (shouldUpdate) {
        await user.save()
      }

      this.$toast.success(this.$t('Customer updated'))
    }
  }
}
</script>
